module.exports = __webpack_public_path__ + "img/logo-dark.d97caece.png";